import lf from 'lovefield'
import { generateSchemas } from './schemas/index.js'
import * as TerrassorConst from '../../terrassor_const.js'
import { NWfunctionCheck, NWCheck, NWcopyUserDataFile, NWwriteFile, NWresetTerrassor, NWreloadTerrassor, NWgetUserTempDataFilePath } from '../../nw/NWfunctions.js'


//import dateFns from 'date-fns'

class LovefieldDB {

  constructor(data) {
    this.db = null;
    this.refs = {};
    this.allJsonData = {}    
  }

  bindAllJsonData(data) {
      this.allJsonData = data;  
  }

  /* BC 2019 - gestion des modes (dont examen)  */
    entreeDebug() {
        var toto = 1;
      console.log('--------------> entreeDebug')
    }

  /* BC 2019 - gestion des modes (dont examen)  */
  mettreEnCoherenceModesUtilisation(allJsonDataDuplicate) {

      console.log('--------------> mettreEnCoherenceModes')

      // BC 2019/03 : mais à quoi sert donc ce test ?
      if ((typeof allJsonDataDuplicate.tables == undefined) || (typeof allJsonDataDuplicate.tables['simu_analyses'] == undefined)) {
            return;
        }


      console.log('--------------> mettreEnCoherenceModes', allJsonDataDuplicate.tables['simu_analyses'])
/*
      if (allJsonDataDuplicate.tables['simu_analyses'][0] == undefined) {
          allJsonDataDuplicate.tables['simu_analyses'][0] = new Object();
      console.log('--------------> mettreEnCoherenceModes simu_analyses', allJsonDataDuplicate.tables['simu_analyses'][0])
        console.log('--------------> mettreEnCoherenceModes : mode ', TerrassorConst.MODE_UTILISATION)
        allJsonDataDuplicate.tables['simu_analyses'][0].mode_utilisation = TerrassorConst.MODE_UTILISATION;
        allJsonDataDuplicate.tables['simu_analyses'][0].etape_epure = 0;
        allJsonDataDuplicate.tables['simu_analyses'][0].etape_epure_atteinte = 0;
    }
      else { // à voir plus tard : passera-t-on par là ?
          var test=1;

      }
*/
  }

/*
* Lecture des données json et 
* 1. rattachement "as is"
* 2. création ou update de la base Terrassor si nécessaire
*/
loadData(allConstData,allChantierData, allEleveData) {


  var allDataTables = this.mergeChantierAndEleveData(allChantierData.tables, allEleveData.tables, allConstData.tables);

  var allJsonData =  {"name": TerrassorConst.DATABASE_NAME, "version": TerrassorConst.REQUIRED_DATABASE_VERSION, "tables":allDataTables}; 
  this.bindAllJsonData(allJsonData)

  var allJsonDataDuplicate = JSON.parse(JSON.stringify(allJsonData))
  // tables non supportées par la BD
  delete allJsonDataDuplicate.tables['const_enginsplus']
  delete allJsonDataDuplicate.tables['const_constantes']
  delete allJsonDataDuplicate.tables['aleas']

  return this.getDbConnection() 
  .then(db => {
      console.log('version actuelle de Terrassor', db.getSchema().version())
      this.dbVersion = db.getSchema().version()

      this.mettreEnCoherenceModesUtilisation(allJsonDataDuplicate)

console.log('loadData : allJsonDataDuplicate', allJsonDataDuplicate)

        return(LovefieldService.importData(allJsonDataDuplicate))

      /*
   var retour = LovefieldService.importData(allJsonDataDuplicate)
   var toto = LovefieldService.exportData()
   var jsonData = JSON.stringify(toto);
    console.log('Pour Bruno', jsonData)
   return retour*/
    })
}


/*
* Création / ouverture de la base (force la recréation en cas d'upgrade nécessaire) 
*/
  getDbConnection() {
console.log('getDbConnection')
    if (this.db != null) {
console.log('getDbConnection not null')
      return Promise.resolve(this.db);
    }

console.log('getDbConnection : null')
    var schemaBuilder = this.buildSchema();

   return Promise.resolve(schemaBuilder.connect({'onUpgrade': this.onUpgradeDB}))
   //return Promise.resolve(schemaBuilder.connect())
      .then(db => {
        this.db = db
console.log('getDbConnection : getSchema')
        this.dbVersion = db.getSchema().version()
        this.onConnected()
        return db;
      })  
  }

/* 
*
*/
  checkDBVersions() {
console.log('getDbConnection : checkDBVersions')
    if(this.dbVersion < TerrassorConst.REQUIRED_DATABASE_VERSION)  {
        //vide la base et recharger l'application
      NWresetTerrassor()
    }
}

/*
*  Pour ttes les tables
* this.refs.<tablename> <- schema de la table
*/
  onConnected() {
    let dbSchema = this.db.getSchema()
    var tables = dbSchema.tables()

    // ajouter les références des tables directement dans this.refs
    // exemple : this.refs.const_cubaturestypes = dbSchema.table("const_cubaturestypes")

    tables.forEach(t => { // version std du foreach  : array.forEach(function(currentValue, index, arr), thisValue)
      name = t.getName();
      this.refs[name] = t;
    }, this);
  }


/*
*
*/
onUpgradeDB(rawDB) {
  var ver = rawDB.getVersion()
  var requiredVer = TerrassorConst.REQUIRED_DATABASE_VERSION
  if(ver == 'undefined' || ver == 0)
     return Promise.resolve(console.log('LovefieldService::onUpgradeDB', ver))

  if(ver < requiredVer)  {
      console.log('onUpgradeDB : upgrade', ver, requiredVer)
        //vider la base et recharger l'application
        NWresetTerrassor()
    }
    else {
      console.log('onUpgradeDB : no upgrade', ver, requiredVer)
    }
}
  /*
  *   Création des tables (if not exists !)
  */
  buildSchema() {
console.log('buildSchema')
    // le schema builder va fournir les primitives comme createTable
    var schemaBuilder = lf.schema.create(TerrassorConst.DATABASE_NAME, TerrassorConst.REQUIRED_DATABASE_VERSION);
console.log('buildSchema : create')
    this.schemaBuilder = schemaBuilder

    // generateSchemas; voir dans db/schemas/index.js    
    generateSchemas(schemaBuilder)
console.log('buildSchema : generateSchemas')
    return schemaBuilder;
  }

/*
* 
* Pour ttes les tables, vérifier si elles ont des données ou non
*/
  isDBEmpty() {
    var tableNames = Object.keys(this.refs)
    var allSelectQueries = tableNames.map(name => this.db.select().from(this.refs[name]).exec())

    return Promise.all(allSelectQueries)
    .then(results => {
      return results.map(resultOfQuery => resultOfQuery.length).every(len => len === 0)
    })
    
  }

/*
* Not used ???
*/
  dropAllTables() {

console.log('dropAllTables');
  return this.getDbConnection()
    .then(db => {
console.log('dropAllTables : getDbConnection ok');
        var tableNames = Object.keys(this.refs)
    /*  tableNames.forEach(t => {
        this.db.dropTable(t) // code RA
      });*/
        console.log('dropAllTables : job must be done');
        var allSelectQueries = tableNames.map(name => this.db.delete().from(this.refs[name]).exec()); // BC
        return Promise.all(allSelectQueries)
        })
    .then(results => {
      console.log('dropAllTables : job is done');
      return results
    })
}

/*
*
*/
 exportAllTerrassor() {
      return this.getDbConnection()
      .then(db => {
         return db.export()
      })
      .then(data => {
        console.log('exportAllTerrassor : DB exported to json successfully', data)
        return data
      })
  }

/*
*
*/
    /*
jsonDataBase (isNW) {
    return this.exportAllTerrassor()
        .then(all => {
            if (typeof(all.tables['simu_analyses']) != 'undefined') {
                var simuAnalyses = all.tables['simu_analyses'][0];
                if ((typeof(simuAnalyses) != 'undefined') && (typeof(simuAnalyses.date_validation) != 'undefined') && simuAnalyses.date_validation) {
                    simuAnalyses.date_validation = this.traiterBugDate(simuAnalyses.date_validation);
                }
                if ((typeof(simuAnalyses) != 'undefined') && (typeof(simuAnalyses.date_etude) != 'undefined') && simuAnalyses.date_etude) {
                    simuAnalyses.date_etude = this.traiterBugDate(simuAnalyses.date_etude);
                }
            }

            if (isNW) {
                var jsonData = JSON.stringify(all);
            }
            else {
                var jsonData = all;
            }
            return(jsonData);
        })
}
traiterBugDate(laDate) {
    laDate = dateFns.addHours(laDate, 12); // décaler à 12:00 pour éviter le changement de jour lors des modifs de timezone été / hiver
    var chaineDate = JSON.stringify(laDate);
    chaineDate = chaineDate.substring(1, 11) + 'T00:00:00+00:00';
    return(new Date(chaineDate));
}
*/

/* BC : lecture du chantier selon un code : valide qu'on a le bon chantier */
    /*
getChantierByCode(code) {
    var tableNames = Object.keys(this.refs)
    var query = this.db.select().from("exo_chantiers").where(exec()
    return this

    return Promise.all(allSelectQueries)
    .then(results => {
      return results.map(resultOfQuery => resultOfQuery.length).every(len => len === 0)
    })

  }
getChantierByCode(code, retour) {
   // On récupère la référence vers la table
    console.warn(retour);
    var t = this.db.tables.exo_chantiers
    var query
    query = db.select().from(t).where(t.code.eq(code)).exec()
    // On retourne la promesse de la requete
    return this.$q.resolve(query)
}
*/

/*
* Init des données à partir des tables exportées de MySQL cf http://asco-pre.privilis.com/exports/json
* Ne marche que sur une BD vide. Ici on simplifie en testant la présence d'au moins une table
* RA 2017.03.20; transformer les dates de mouvements en Date()
*/
  importData(data) {

    var lanalyse = this.transformDatesAnalyse(data.tables['simu_analyses'][0])
    data.tables['simu_analyses'][0] = lanalyse

    var m_array = this.transformDatesMouvements(data.tables['simu_mouvements'])
    //data['simu_mouvements'] = m_array // BC 2017/11 arghhhh - il manque .tables .... est-ce que ça veut dire que la bidouille au dessus ne sert à rien ?
        // où plus probablement, si je comprends bien, que transformDatesMouvements agit directement sur l'objet passé en paramètre :)
    data.tables['simu_mouvements'] = m_array

    return this.isDBEmpty()
    .then(isEmpty => {
      if(!isEmpty) {
              console.warn("La base Terrassor est déjà renseignée. L'import n'est disponible que pour une base vide.");
              console.warn('Utilisation des données actuelles de la base.');
              console.warn(this.db);
              return Promise.resolve(this.db);
      }

      console.warn('Réinitialisation de la base Terrassor.')        
      return this.db.import(data)
    })// fct native lf
    .then(() => this.db)
  }

  /*
  * Champs debut et fin de simu-mouvements passés du format Json/ISOString en objet Date()
  */
  transformDatesMouvements(m_array) {
  if(!m_array)
    return;
  m_array.forEach(m => {
    m.debut = new Date(m.debut)
    m.fin = new Date(m.fin)
  })
  return m_array
}
  transformDatesAnalyse(analyse) {
  if(!analyse)
    return;

    if ((typeof(analyse.date_etude) != 'undefined') && analyse.date_etude) {
        analyse.date_etude = new Date(analyse.date_etude)
    }
    if ((typeof(analyse.date_validation) != 'undefined') && analyse.date_validation) {
        analyse.date_validation = new Date(analyse.date_validation)
    }

      return analyse
}



  exportData() {
    return this.db.export()
      .then(data => {
        console.log('exportData : DB exported to json successfully', data)
        return data
      })
  }

  /*
  *
  */

  /*
* nom des tables élève (étude)
*/
 eleveDataTables (complet) {
    var tableNamesComplet = ['simu_analyses','simu_cubatures','simu_echelons','simu_echelons_simu_engins','simu_eleves', 'simu_engins', 'simu_etudes',
                    'simu_etudes_exo_cubatures_exo_mouvements', 'simu_installations', 'simu_installations_const_installations', /*'simu_installations_const_equipementsprestations', */
                    'simu_mouvements',
                    'simuexo_chantiers', 'simuexo_cubatures', 'simuexo_cubatures_couches', 'simuexo_mouvements', 'simuexo_mouvements_simuexo_cubatures',
                    'exo_chantiers', 'exo_cubatures', 'exo_mouvements', 'exo_cubatures_exo_mouvements'];
    var tableNames = ['simu_analyses','simu_cubatures','simu_echelons','simu_echelons_simu_engins','simu_eleves', 'simu_engins', 'simu_etudes',
                    'simu_etudes_exo_cubatures_exo_mouvements', 'simu_installations', 'simu_installations_const_installations', /*'simu_installations_const_equipementsprestations', */
                    'simu_mouvements',
                    'simuexo_chantiers', 'simuexo_cubatures', 'simuexo_cubatures_couches', 'simuexo_mouvements', 'simuexo_mouvements_simuexo_cubatures'];
                    // 'simuexo_chantiers', 'simuexo_cubatures', 'simuexo_cubatures_couches', 'simuexo_cubatures_simuexo_cubatures']
     if (complet) {
            return(tableNamesComplet);
         }
    return(tableNames);
 }



  /*
* Ajout des tables simu de l'élève ; si pas de donbnées élèves, vider les tables 'simu'
*/
 mergeChantierAndEleveData (c_data, e_data, consts)
{

  /*if(!c_data || !consts)
    return  */
if(!consts)
    return
    var complet = false;
if(!c_data) {
    c_data = {};
    complet = true;
}

console.log('mergeChantierAndEleveData : consts', consts)
console.log('mergeChantierAndEleveData : c_data', c_data)
console.log('mergeChantierAndEleveData : e_data', e_data)


  var datas = jQuery.extend(c_data, consts); // priorité à consts

  var tableNames = this.eleveDataTables(complet)
  
  if(!e_data || e_data.length == 0)
  {
    tableNames.forEach(name => {datas[name] = []})
    return datas
  }

//remplacer / insérer les données élèves
console.log('mergeChantierAndEleveData 1 : datas', datas)
 tableNames.forEach(name => {
console.log('mergeChantierAndEleveData : tableNames.forEach - ', name)
     datas[name] = e_data[name]
 })
console.log('mergeChantierAndEleveData 2 : datas', datas)

 return datas

}




  // -----------------------

 }

export const LovefieldService = new LovefieldDB()



// WEBPACK FOOTER //
// ./src/client/common/db/LovefieldService.js